module.exports = __webpack_public_path__ + "static/media/veranda-innovation.18d86c19.png";